import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { partial } from '../../common/utils/partial';

import { getCurrentUser } from '../../user/user.selectors';
import { getAllChannels } from '../../channel/channel.selectors';
import { getAllTeams } from '../../team/team.selectors';

import buttonThemes from '../../../ui/button/buttonThemes';
import { UserRoles } from '../../user/user.constants';
import { Localize } from '../../../locale/localization';
import Button from '../../../ui/button/Button';
import styled from 'styled-components';
import colorThemes from '../../../ui/colorThemes';

const Wrapper = styled.div`
	text-align: center;
	
	li {
		padding: 0.25rem 1rem;
		
		&.last {
			padding-top: 1rem;
		}
	}
`;

class AddUserEntityContainer extends Component {

	onClick = (path, replace = false) => {
		const { history } = this.props;
		if(!replace) {
			history.push(path);
		} else {
			history.replace(path);
		}
	}

	render() {
		const {
			currentUser,
			cancelPath,
			channels,
			teams
		} = this.props;
		const { role } = currentUser;

		const hasChannels = channels.length > 0;
		const hasTeams = teams.length > 0;

		const canSeeChannelsButton = role === UserRoles.SUPERUSER;
		const canSeeRegionsButton = (role === UserRoles.SUPERUSER || role === UserRoles.SALESMANAGER);
		const canSeeTeamsButton = (role === UserRoles.SUPERUSER || role === UserRoles.SALESMANAGER || role === UserRoles.REGIONMANAGER);
		const canSeeUsersButton = (role === UserRoles.SUPERUSER || role === UserRoles.SALESMANAGER || role === UserRoles.REGIONMANAGER || role === UserRoles.TEAMLEADER);

		const canAddChannels = canSeeChannelsButton;
		const canAddRegions = hasChannels && canSeeRegionsButton;
		const canAddTeams = hasChannels && canSeeTeamsButton;
		const canAddUsers = hasChannels && hasTeams && canSeeUsersButton;

		return (
			<Wrapper>
				<ul>
					{canSeeChannelsButton && (
						<li>
							<Button
								onClick={partial(this.onClick, '/admin/users/add/channel')}
								disabled={!canAddChannels}
								theme={buttonThemes.SECONDARY}
								minWidth
								icon="#chevron-right"
								iconRight={true}
							>
								{Localize('admin.add.channel')}
							</Button>
						</li>
					)}
					{canSeeRegionsButton && (
						<li>
							<Button
								onClick={partial(this.onClick, '/admin/users/add/region')}
								disabled={!canAddRegions}
								theme={buttonThemes.SECONDARY}
								minWidth
								icon="#chevron-right"
								iconRight={true}
							>
								{Localize('admin.add.region')}
							</Button>
						</li>
					)}
					{canSeeTeamsButton && (
						<li>
							<Button
								onClick={partial(this.onClick, '/admin/users/add/team')}
								disabled={!canAddTeams}
								theme={buttonThemes.SECONDARY}
								minWidth
								icon="#chevron-right"
								iconRight={true}
							>
								{Localize('admin.add.team')}
							</Button>
						</li>
					)}
					{canSeeUsersButton && (
						<li>
							<Button
								onClick={partial(this.onClick, '/admin/users/add/user')}
								disabled={!canAddUsers}
								theme={buttonThemes.SECONDARY}
								minWidth
								icon="#chevron-right"
								iconRight={true}
							>
								{Localize('admin.add.sales.person')}
							</Button>
						</li>
					)}
					{canSeeUsersButton && (
						<li>
							<Button
								onClick={partial(this.onClick, '/admin/users/add/assistant')}
								disabled={!canAddUsers}
								theme={buttonThemes.SECONDARY}
								minWidth
								icon="#chevron-right"
								iconRight={true}
							>
								{Localize('admin.add.assistant')}
							</Button>
						</li>
					)}
					<li className="last">
						<Button
							onClick={partial(this.onClick, cancelPath, true)}
							theme={colorThemes.LIGHT}
							minWidth
						>
							{Localize('action.cancel')}
						</Button>
					</li>
				</ul>
			</Wrapper>
		);
	}
};

const mapStateToProps = (state) => {
	const currentUser = getCurrentUser(state);
	const channels = getAllChannels(state);
	const teams = getAllTeams(state);
	return {
		currentUser,
		channels,
		teams,
	};
};

const ConnectedAddUserEntityContainer = connect(
	mapStateToProps,
	Object.assign({}),
)(AddUserEntityContainer);

export default withRouter(ConnectedAddUserEntityContainer);


// WEBPACK FOOTER //
// ./src/modules/user/components/AddUserEntityContainer.js